export { DIAMONDS_ACTION_TYPES } from './diamonds';

export const STORE_INIT = 'STORE_INIT';
